const brand = {
  blue: '#038ab7',
  green: '#4d9927',
  hoverGreen: '#438522',
  activeGreen: '#2e5c17',
}

export default brand
